import accidentInsurance from './accident-insurance.js';
import agreement from './agreement';
import declarationType from './declaration-type.js';
import declaration from './declaration.js';
import leaveCode from './leave-code.js';
import leave from './leave.js';
import partnerStaff from './partner-staff';
import partnerStaffBoardMember from './partner-staff-board-memeber';
import plenipotentiary from './plenipotentiary.js';
import staff from './staff.js';

export default {
  accidentInsurance,
  agreement,
  declaration,
  declarationType,
  partnerStaff,
  partnerStaffBoardMember,
  plenipotentiary,
  staff,
  leave,
  leaveCode,
};
